import APIController from '../core-api-controller';

export const fetchExportsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/exports${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const exportTableApi = (data = {}) => {
  const path = `${APIController.endpointApi}/exports`;
  return APIController.postCallback(path, data);
};
